import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShareService } from '../../Services/share.service';
import { ApiServiceService } from '../../pages/tracking/api-service.service';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';

@Component({
  selector: 'app-share-csv-dialog',
  templateUrl: './share-csv-dialog.component.html',
  styleUrls: ['./share-csv-dialog.component.scss']
})
export class ShareCsvDialogComponent {

  shareCsvForm: FormGroup;
  formData: FormData = new FormData();
  constructor(public dialogRef: MatDialogRef<ShareCsvDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private fb: FormBuilder,
public excelService: ShareService, private _service: ApiServiceService,public dialog: MatDialog){
    this.shareCsvForm = this.fb.group({
      FileName: [''],
      EmailIds: ['', [Validators.required, Validators.email]],
      Subject: ['', Validators.required],
      Body: ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.data
  }

  excelData: any[] = [];
  onSubmit() {
    if (this.shareCsvForm.valid) {
      if (this.data != null) {
        this.excelData.push({
          'Booking Id': this.data['booking_id'],
          'Service Type': this.data['order_type'],
          'Order Id': this.data['OrderId'],
          'XPCN/XPLS Number': this.data['XPCN'] + this.data['mXPCN'],
          'Origin': this.data['From'],
          'To': this.data['To'],
          'Order Status': this.data['StatusOfOrder'],
          'Consignor Name': this.data['vc_consignor_name'],
          'Consignee Name': this.data['consignee_name'],
          'Picked Date and Time': this.data['Load_picked_date'],
          'Current Location': this.data['Location'],
          'Status': this.data['StatusOfOrder']
        });

        let blob = this.excelService.exportAsExcelFileBlob(this.excelData, 'Tracking');
        this.shareCsvForm.controls['FileName'].setValue("Order Details.xlsx");
        console.log(blob);
        this.formData.append('123', blob);
        this.formData.delete('FormData');
        this.formData.append('FormData', JSON.stringify(this.shareCsvForm.value));
        this._service.sendEmailsWithCSV(this.formData).subscribe((res: any) => {
          console.log(res);
          if (res['Success'] == true) {
            this.dialogRef.close()
            this.dialog.open(MessageDialogComponent, {
              width: '250px',
              data: {Message:"Email Sent Successfully", icon:"fa fa-check-circle-o success-icon"}
            });
          }
        });
      } else {
        console.log('Data is null');
      }
    } else {
      console.log('Form is invalid');
    }
  }
}
